import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./consumerPurchaseManageSlice";
import { reduceArr } from "@utils/helpers";

const selectDomain = (state) => state.consumerPurchaseManage || initialState;

export const makeSelectQuery = createSelector(
    selectDomain,
    (state) => state.query
);
export const makeSelectOne = createSelector(
    selectDomain,
    (state) => state.one
);

export const makeSelectRegisterData = createSelector(
    selectDomain,
    (state) => state.registerData
);

export const makeSelectSelectedProduct = createSelector(
    selectDomain,
    (state) => state.selectedProduct
);

export const makeSelectSliderData = createSelector(
    selectDomain,
    (state) => state.sliderData
)

export const makeSelectPaymentMethodData = createSelector(
    selectDomain,
    (state) => state.paymentMethod
)

export const makeSelectStateLocation = createSelector(
    selectDomain,
    (state) => state.stateLocation
);

export const makeSelectStateOptions = createSelector(
    makeSelectStateLocation,
    (stateLocation) => {
        const stateOptions =
            stateLocation?.map((each) => ({
                label: each.name,
                value: each._id,
            })) || [];

        return stateOptions;
    }
);

export const makeSelectStateOptionsNormalized = createSelector(
    makeSelectStateOptions,
    (stateOptions) => {
        const stateOptionsNormalized = reduceArr(stateOptions);

        return stateOptionsNormalized;
    }
);

export const makeSelectDistrictLocation = createSelector(
    selectDomain,
    (state) => state.districtLocation
);

export const makeSelectDistrictOptions = createSelector(
    makeSelectDistrictLocation,
    (districtLocation) => {
        const districtOptions =
            districtLocation?.map((each) => ({
                label: each.name,
                value: each._id,
            })) || [];

        return districtOptions;
    }
);

export const makeSelectDistrictOptionsNormalized = createSelector(
    makeSelectDistrictOptions,
    (districtOptions) => {
        const districtOptionsNormalized = reduceArr(districtOptions);

        return districtOptionsNormalized;
    }
);

export const makeSelectVdcOptions = createSelector(
    selectDomain,
    (state) => state.vdcOptions
);

export const makeSelectVdcLocation = createSelector(
    selectDomain,
    (state) => state.vdcLocation
);


export const makeSelectVdcMunicipalityOptions = createSelector(
    makeSelectVdcLocation,
    (vdcLocation) => {
        const vdcOptions =
            vdcLocation?.map((each) => ({
                label: each.name,
                value: each._id,
            })) || [];

        return vdcOptions;
    }
);

export const makeSelectVdcOptionsNormalized = createSelector(
    makeSelectVdcMunicipalityOptions,
    (vdcOptions) => {
        const vdcOptionsNormalized = reduceArr(vdcOptions);

        return vdcOptionsNormalized;
    }
);

export const makeSelectOfficeByType = createSelector(
    selectDomain,
    (state) => state.officeByType
);

export const makeSelectOfficeOptions = createSelector(
    makeSelectOfficeByType,
    (officeByType) => {
        const officeOptions =
            officeByType?.map((each) => ({
                label: each.name,
                value: each.office_code
            })) || [];

        return officeOptions;
    }
);

export const makeSelectOfficeOptionsNormalized = createSelector(
    makeSelectOfficeOptions,
    (officeOptions) => {
        const officeOptionsNormalized = reduceArr(officeOptions);

        return officeOptionsNormalized;
    }
);

export const makeSelectBank = createSelector(
    selectDomain,
    (state) => state.bankList
);

export const makeSelectBankListOptions = createSelector(
    makeSelectBank,
    (bankList) => {
        const bankOptions =
            bankList?.map((each) => ({
                label: each,
                value: each
            })) || [];

        return bankOptions;
    }
);

export const makeSelectBankListOptionsNormalized = createSelector(
    makeSelectBankListOptions,
    (bankOptions) => {
        const bankOptionsNormalized = reduceArr(bankOptions);

        return bankOptionsNormalized;
    }
);

